import { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../../../redux/actions';

// เอกสารฝั่ง Sale (quotation/DN/BL/receipt/tax invoice) ที่ผูกกับ opportunity นี้ผ่าน
// Document.opportunity_id (loose reference ข้าม database ไปยัง marketing_opportunities.id
// — ดู backend/models/Document.js) คนละระบบกับ marketing_tender_documents ที่เป็นไฟล์แนบ
export function useOpportunityDocuments(opportunityId) {
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const hasLoadedRef = useRef(false);

  const fetchDocs = useCallback(async () => {
    if (!hasLoadedRef.current) setLoading(true);
    try {
      const data = await dispatch(actions.documentAll({ opportunity_id: opportunityId, limit: 100 }));
      setRows(data?.rows || []);
      hasLoadedRef.current = true;
    } finally {
      setLoading(false);
    }
  }, [dispatch, opportunityId]);

  useEffect(() => { fetchDocs(); }, [fetchDocs]);

  return { rows, loading, refetch: fetchDocs };
}

export default useOpportunityDocuments;
